/**
 * Check if script runs in browser by comparing document to undefined
 */
export function isInBrowser(): boolean {
  return typeof document !== 'undefined';
}

export function getWindowLocation(): string {
  if (isInBrowser()) {
    return window.location.href;
  }
  return '';
}
